import { Outlet as OutletNative } from 'react-router';

import type { PropsWithChildren } from 'react';

export const Outlet = ({ children }: PropsWithChildren) => children ?? <OutletNative />;
